interface HeadphonesSupportProps {
  color: string;
}

function HeadphonesSupport({ color }: HeadphonesSupportProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.0037 12C21.0037 16.9726 16.9726 21.0037 12 21.0037"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.99609 11.9998C2.99609 7.02721 7.02721 2.99609 11.9998 2.99609"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.99609 11.9992C2.99623 13.0539 3.18381 14.1001 3.55008 15.0891C3.71759 15.5484 4.18986 15.822 4.67165 15.7388L5.65825 15.5648C6.45566 15.4242 6.99772 14.6764 6.88321 13.8748L6.58627 11.7962C6.52878 11.3938 6.31051 11.032 5.98139 10.7934C5.65227 10.5549 5.24046 10.46 4.84015 10.5306L3.07883 10.8412"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0037 11.9998C21.0037 7.02721 16.9726 2.99609 12 2.99609"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.002 11.9992C21.0018 13.0539 20.8143 14.1001 20.448 15.0891C20.2805 15.5484 19.8082 15.822 19.3264 15.7388L18.3398 15.5648C17.5424 15.4242 17.0004 14.6764 17.1149 13.8748L17.4118 11.7962C17.4693 11.3938 17.6876 11.032 18.0167 10.7934C18.3458 10.5549 18.7576 10.46 19.1579 10.5306L20.9192 10.8412"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4924 12.4908C13.4894 12.4908 13.4866 12.4926 13.4855 12.4954C13.4843 12.4982 13.485 12.5014 13.4871 12.5035C13.4892 12.5057 13.4925 12.5063 13.4952 12.5052C13.498 12.504 13.4999 12.5013 13.4999 12.4983C13.5 12.4962 13.4992 12.4943 13.4978 12.4928C13.4964 12.4914 13.4944 12.4907 13.4924 12.4908"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5061 12.4927C10.503 12.4927 10.5003 12.4946 10.4992 12.4974C10.498 12.5002 10.4986 12.5034 10.5008 12.5055C10.5029 12.5076 10.5061 12.5083 10.5089 12.5071C10.5117 12.506 10.5135 12.5032 10.5135 12.5002C10.5137 12.4982 10.5129 12.4962 10.5115 12.4948C10.5101 12.4933 10.5081 12.4926 10.5061 12.4927"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default HeadphonesSupport;
